<template>
  <b-card class="fee-card">
    <template #header>
      <img
        :src="fee.logo"
        :alt="fee.method"
        :class="`${fee.method}-logo`"
      >
    </template>
    <b-card-text>
      <div
        dir="ltr"
        class="fee-percent-container"
      >
        <span class="fee-percent">{{ fee.percent }}%</span>
        <span
          v-if="fee.fixed"
          class="fee-fixed"
        >
          +{{ fee.fixed }} {{ currency }}
        </span>
      </div>
      <div class="fee-minimum">
        {{ $t('payment.minimum-fees') }}: {{ fee.minimum }} {{ currency }}
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  name: 'FeeCard',
  components: { BCard, BCardText },
  props: {
    fee: {
      type: Object,
      required: true,
    },
    currency: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.fee-card {
  text-align: center;

  .card-header {
    height: 52px;
    padding: 13px 5px;
    text-align: center;
    border: solid 1px #d8d6de;
    background-color: #fafafa;

    img {
      margin: auto;
      height: 100%;
      max-height: 20px;
      width: auto;

      &.master-logo, &.knet-logo {
        max-height: 24px;
      }
    }
  }

  .card-body {
    padding: 24px 0 21px!important;
    border: solid 1px #d8d6de;
    border-top: 0;
    border-radius: 0 0 5px 5px;

    .fee-percent {
      font-size: 30px;
      font-weight: 600;
      line-height: 1.23;
      color: var(--purple);
    }

    .fee-fixed {
      font-size: 10px;
      line-height: 1.3;
      color: #FF055D;
    }

    .fee-percent-container {
      margin-bottom: 2px;
    }

    .fee-minimum {
      font-size: 12px;
      line-height: 1.25;
      color: #aaa8b2;
    }
  }
}
</style>
